import { COUNTRIES } from "../lib/countries";

export const CountrySelect = ({ value, onChange, testid = "country-filter-select" }) => (
  <label className="inline-flex items-center gap-2 text-xs font-mono min-w-0 max-w-full">
    <span className="text-muted-foreground">country =</span>
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value || null)} className="h-9 min-w-0 max-w-full rounded border bg-card px-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-ring">
      <option value="">None (worldwide)</option>
      {COUNTRIES.map((c) => <option key={c.code} value={c.code}>{c.name} ({c.code})</option>)}
    </select>
  </label>
);
